import type { ProtectedProps } from '@/components/renters/Protected';
import { Section, SectionParagraph as Subtitle, SectionTitle as Title } from '@/components/shared/Content';
import Bandage from '@/static/assets/dating/bandage.svg';
import Time from '@/static/assets/dating/time.svg';
import Wine from '@/static/assets/dating/wine.svg';
import { Flex, LegacyText, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import Image from 'next/image';
import styled from 'styled-components';

const StyledTitle = styled(Title)`
  text-align: center;
`;

const StyledSubtitle = styled(Subtitle)`
  text-align: center;
  margin-top: 20px;
`;

export const ProtectedItem = styled(Flex)`
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  flex: 1 1 0%;

  ${MEDIA_QUERIES.mobile`
        margin-bottom: 26px;

        &:last-child {
            margin-bottom: 0;
        }
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        flex-direction: column;
        flex: 0 1 308px;
    `}
`;

export const ItemTitle = styled(LegacyText).attrs<unknown>({
  fontWeight: 'bold',
  fontSize: ['2rem', '2.5rem'],
  color: `${themedColor('night')}`,
  textAlign: 'center',
  as: 'h2',
  type: 'main',
})`
  white-space: nowrap;
  margin-top: 10px;
`;

export const CustomSection = styled(Section)`
  background-image: linear-gradient(rgb(247, 247, 247) 80%, rgba(255, 255, 255, 0.5) 100%);
`;

export const ItemSubtitle = styled(LegacyText).attrs<unknown>({
  fontSize: '1.6rem',
  lineHeight: '1.5',
  color: `${themedColor('night')}`,
  textAlign: 'center',
  as: 'p',
  type: 'main',
})``;

const ProtectedContainer = styled(Flex)<{ items: number }>`
  margin-top: 55px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px 40px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        justify-content: center;
        flex-direction: row;
        position: relative;

        ${ProtectedItem} {
            flex: ${({ items }) => (items === 3 ? '0 1 234px;' : '0 1 318px;')};
            margin: ${({ items }) => (items === 3 ? '0 10px' : '0 40px;')};


    `}

  ${MEDIA_QUERIES.tablet`
        width: 100%;
        margin-top: 60px;

        &:last-child {
            width: 500px !important;
        }
    `}
`;

const ITEMS = [
  {
    title: 'All Expenses Covered',
    text: 'Dinner, drinks, transportation, and reservation cancelation fees.',
    image: Wine,
  },
  {
    title: 'Self-care Add-on',
    text: 'Cover therapy, spa days, and ice cream.',
    image: Bandage,
  },
  {
    title: 'Super-fast & Simple',
    text: 'Spend less time on paperwork and more time on better choices.',
    image: Time,
  },
];

export const Protected = ({ title, subtitle }: ProtectedProps) => {
  return (
    <CustomSection px={20} pt={[130, 160]} pb={[60, 96]}>
      <StyledTitle>{title}</StyledTitle>
      <StyledSubtitle>{subtitle}</StyledSubtitle>
      <ProtectedContainer items={3}>
        {ITEMS.map(item => (
          <ProtectedItem key={item.title} alignItems="center">
            <Image src={item.image} alt={item.title} />
            <ItemTitle>{item.title}</ItemTitle>
            <ItemSubtitle>{item.text}</ItemSubtitle>
          </ProtectedItem>
        ))}
      </ProtectedContainer>
    </CustomSection>
  );
};
